import { useRef } from "react";
import AboutSection from "./AboutSection";
import ContactFormSection from "./ContactFormSection";
import Footer from "./Footer";
import Notification from "./Notification";
import SocialLinks from "./SocialLinks";
import TestimonialsSection from "./TestimonialsSection";
import TimelineSection from "./TimelineSection";
import TopNav from "./TopNav";
import WorksSection from "./WorksSection";

import "./portrait-large-layout.css";

function PortraitLargeLayout() {
  const aboutRef = useRef(null);
  const worksRef = useRef(null);
  const experienceRef = useRef(null);
  const contactRef = useRef(null);
  const mainDivRef = useRef(null);
  const preventIntersectionObserver = useRef(false);

  return (
    <div
      className="w-full h-full overflow-y-auto overflow-x-hidden"
      ref={mainDivRef}
    >
      <div className="w-full h-max flex flex-col">
        <TopNav
          className="sticky top-0"
          aboutRef={aboutRef}
          worksRef={worksRef}
          experienceRef={experienceRef}
          contactRef={contactRef}
          mainDivRef={mainDivRef}
          preventIntersectionObserver={preventIntersectionObserver}
        />
        <Notification />
        <div className="flex flex-row w-full h-max">
          <div className="grow h-max">
            <AboutSection
              ref={aboutRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <WorksSection
              ref={worksRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <TimelineSection
              ref={experienceRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <TestimonialsSection
              preventIntersectionObserver={preventIntersectionObserver}
            />
            <ContactFormSection
              ref={contactRef}
              preventIntersectionObserver={preventIntersectionObserver}
            />
          </div>
          <div
            style={{ height: "calc(97vh - 60px)" }}
            className="w-max sticky top-[60px] flex flex-col justify-end"
          >
            <SocialLinks className="mx-2 sticky top-[20%] mb-4" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PortraitLargeLayout;
